import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const REVIEWS = [
  { name: "Rosario R.", source: "TheFork", score: "10/10", stars: 5, text: "Tutto super buono, locale bellissimo: si mangia da leccarsi i baffi.", big: true },
  { name: "Aurora G.", source: "TheFork", score: "10/10", stars: 5, text: "La pizza era buonissima e molto leggera, ambiente accogliente e prezzi onesti. La consiglio a chi cerca una vera buona pizza!" },
  { name: "Simona Privitera", source: "Google", score: "5/5", stars: 5, text: "I ragazzi sono gentili, simpatici e superdisponibili." },
  { name: "Patrizia V.", source: "TheFork", score: "10/10", stars: 5, text: "Buonissimo e bellissimo. I migliori in assoluto." },
  { name: "Daniele Bonomo", source: "Google", score: "4/5", stars: 4, text: "La pizza è buona, sia l'impasto che gli ingredienti." },
  { name: "Elisa D.", source: "TheFork", score: "10/10", stars: 5, text: "Pizza buonissima, personale altrettanto gentile. Il menù è molto vasto e l'attesa non è per niente lunga." },
];

export default function Reviews() {
  return (
    <section id="recensioni" data-testid="reviews-section" className="relative py-28 sm:py-40 bg-coal border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="text-[11px] tracking-[0.45em] uppercase text-terra"
        >
          Le Recensioni
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream mt-4"
        >
          Cosa dicono <span className="italic text-gold">di noi.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-cream/50 text-sm mt-5 max-w-xl leading-relaxed"
        >
          Parole vere dei nostri clienti, dalle pagine Google e TheFork.
        </motion.p>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-16">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: EASE }}
              className={`group bg-coal p-8 sm:p-10 flex flex-col hover:bg-ink transition-colors duration-500 ${
                r.big ? "md:col-span-2" : ""
              }`}
            >
              <Quote size={26} strokeWidth={1.2} className="text-terra group-hover:text-gold transition-colors duration-500" />
              <blockquote className={`font-display italic text-cream/90 leading-snug mt-6 flex-1 ${r.big ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"}`}>
                “{r.text}”
              </blockquote>
              <figcaption className="flex items-center justify-between mt-8 pt-6 border-t border-white/10">
                <div>
                  <span className="text-cream text-sm">{r.name}</span>
                  <span className="block text-[10px] tracking-[0.3em] uppercase text-cream/40 mt-1">
                    Recensione {r.source}
                  </span>
                </div>
                <div className="flex items-center gap-1" aria-label={`${r.score}`}>
                  {Array.from({ length: r.stars }).map((_, s) => (
                    <Star key={s} size={12} className="text-gold fill-gold" />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
